const s = "_wrapper_17lrm_1", r = "_error_17lrm_15", e = "_success_17lrm_19", _ = "_info_17lrm_23", o = "_message_17lrm_27", c = "_heading_17lrm_31", n = "_list_17lrm_34", t = {
  wrapper: s,
  error: r,
  success: e,
  info: _,
  message: o,
  heading: c,
  list: n
};
export {
  t as default,
  r as error,
  c as heading,
  _ as info,
  n as list,
  o as message,
  e as success,
  s as wrapper
};
